var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-list"},[_c('div',{staticClass:"property-label"},[_vm._v(_vm._s(_vm.label))]),_c('ul',_vm._l((_vm.items),function(item,idx){return _c('li',{key:`${item}-${idx}`},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }